module.exports = __webpack_public_path__ + "TextaNarrow-Heavy-webfont.554507c6bd221fcbd5bd.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/TextaNarrow-Heavy-webfont.woff2
// module id = ../../../../../src-admin/assets/fonts/TextaNarrow-Heavy-webfont.woff2
// module chunks = styles